import { render, staticRenderFns } from "./FeatureDetail.vue?vue&type=template&id=6c301890&scoped=true&"
import script from "./FeatureDetail.vue?vue&type=script&lang=ts&"
export * from "./FeatureDetail.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureDetail.vue?vue&type=style&index=0&id=6c301890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c301890",
  null
  
)

export default component.exports